import { Observable, catchError, EMPTY } from 'rxjs';
import { DialogConfig, DialogRef , Dialog } from '@angular/cdk/dialog';

import { isObject } from '@core/helpers';
import { FormattedError } from '@core/http';

import { Captcha } from './captcha.interface';
import { CaptchaDialog } from './captcha.dialog';

function isCaptchaError(body: any): body is Captcha {
  return !!body.captcha;
}

export function catchCaptcha<T>(
  dialog: Dialog,
  onSuccess: () => void
): (source: Observable<T>) => Observable<T> {
  return (source: Observable<T>): Observable<T> => source.pipe(
    catchError((err: any) => {
      if(err instanceof FormattedError) {
        // eslint-disable-next-line rxjs/throw-error
        throw err;
      }

      const isValidResponse = isObject(err.error) && 'data' in err.error;

      if(isValidResponse && isCaptchaError(err.error.data)) {
        const { captcha } = err.error.data;
        const dialogParams: DialogConfig<unknown, DialogRef<string, CaptchaDialog>> = {
          disableClose: true,
          data: {
            captcha,
            onSuccess
          }
        };

        dialog.open(CaptchaDialog, dialogParams);

        return EMPTY;
      }

      throw err;
    })
  );
}